// Curried language picker: pickLang(lang) returns an L() that resolves a
// { uk, en, ru } object to the current language, falling back to English.
// Replaces the per-component `const L = (o) => (o && o[lang]) || (o && o.en)`
// duplicated in FAQPage.js and SupportPage.js.
export const pickLang = (lang) => (o) => (o && o[lang]) || (o && o.en);
